/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandAndMarketListItemAutocompleteResult
 */
export interface BrandAndMarketListItemAutocompleteResult {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof BrandAndMarketListItemAutocompleteResult
     */
    results?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof BrandAndMarketListItemAutocompleteResult
     */
    numberOfItems?: number;
}

export function BrandAndMarketListItemAutocompleteResultFromJSON(json: any): BrandAndMarketListItemAutocompleteResult {
    return BrandAndMarketListItemAutocompleteResultFromJSONTyped(json, false);
}

export function BrandAndMarketListItemAutocompleteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarketListItemAutocompleteResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'numberOfItems': !exists(json, 'numberOfItems') ? undefined : json['numberOfItems'],
    };
}

export function BrandAndMarketListItemAutocompleteResultToJSON(value?: BrandAndMarketListItemAutocompleteResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(BrandAndMarketListItemToJSON)),
        'numberOfItems': value.numberOfItems,
    };
}


